import { Command } from './Command';
import { VideoEditor } from '../VideoEditor';
import { Track } from '../models/Track';
import { EditorChangeType } from '../types';

export class TrackLayerDownCommand implements Command {
  private editor: VideoEditor;
  private originalTrackId: string;
  private track?: Track;
  private executed: boolean = false;

  constructor(editor: VideoEditor, trackId: string) {
    this.editor = editor;
    this.originalTrackId = trackId;
    this.track = editor.getTrackById(trackId);
  }

  execute(): boolean {
    if (!this.track) return false;

    const trackManager = this.editor.getTrackManager();
    const result = trackManager.shiftTrackLayer(this.track.id, 'down');

    if (result) {
      this.executed = true;

      this.editor.markDirty('track_layer_down_command');

      this.editor.notifyObservers(EditorChangeType.TRACK_LAYER_CHANGED, {
        direction: 'down',
        trackId: this.track.id,
        track: this.editor.timeline.getTrack(this.track.id),
        targetTrackId: result,
      });

      return true;
    }

    return false;
  }

  undo(): boolean {
    if (!this.executed || !this.track) return false;

    const trackManager = this.editor.getTrackManager();
    const success = trackManager.shiftTrackLayer(this.track.id, 'up');

    if (success) {
      this.executed = false;

      this.editor.markDirty('track_layer_down_command_undo');

      this.editor.notifyObservers(EditorChangeType.TRACK_LAYER_CHANGED, {
        direction: 'up',
        trackId: this.track.id,
        track: this.editor.timeline.getTrack(this.track.id),
        targetTrackId: this.originalTrackId,
      });

      return true;
    }

    return false;
  }

  redo(): boolean {
    if (this.executed) return false;
    return this.execute();
  }

  getDescription(): string {
    return `Move track ${this.originalTrackId} layer down`;
  }
}
